import { createContext } from "react";
import SearchQuery from "~/searchQuery";

interface ISearchBarContext {
  searchQuery: SearchQuery;
  setSearchQuery: (value: SearchQuery) => void;
}

export default createContext<ISearchBarContext>({} as any);
